<template>
	<LayoutForm>
		<h1 slot="header">Create Opportunity</h1>

		<FormStepNav slot="nav" :total-steps="totalSteps" :current-step="currentStep"
		             :completed-step="completedStep" :route-base="routeBase">
		</FormStepNav>

		<OpportunityFormStep1 v-if="currentStep === 1"></OpportunityFormStep1>
		<OpportunityFormStep2 v-if="currentStep === 2"></OpportunityFormStep2>
		<OpportunityFormStep3 v-if="currentStep === 3"></OpportunityFormStep3>
		<OpportunityFormStep4 v-if="currentStep === 4"></OpportunityFormStep4>
		<OpportunityFormStep5 v-if="currentStep === 5"></OpportunityFormStep5>
	</LayoutForm>
</template>

<script>
	import API from '../../api';
	import LayoutForm from '../Layout/LayoutForm';
	import MultiStepForm from '../Form/MultiStepForm';
	import OpportunityFormStep1 from './Form/OpportunityFormStep1';
	import OpportunityFormStep2 from './Form/OpportunityFormStep2';
	import OpportunityFormStep3 from './Form/OpportunityFormStep3';
	import OpportunityFormStep4 from './Form/OpportunityFormStep4';
	import OpportunityFormStep5 from './Form/OpportunityFormStep5';
	import FormStepNav from '../Form/FormStepNav';
	import format from 'date-fns/format';

	export default {
		name: 'OpportunityForm',
		mixins: [MultiStepForm],
		components: {
			FormStepNav,
			OpportunityFormStep1,
			OpportunityFormStep2,
			OpportunityFormStep3,
			OpportunityFormStep4,
			OpportunityFormStep5,
			LayoutForm,
		},
		data() {
			return {
				totalSteps: 5,
				routeBase: (this.id) ? `/opportunities/${ this.id }/edit` : '/opportunities/create',
			}
		},
		methods: {
			fetchResource(id) {
				return API.getOpportunity(id);
			},
			sanitizeResource(opp) {
				this.$store.commit('selectCache/addUser', opp.lead);
				opp.lead = opp.lead.id;

				if(Array.isArray(opp.team)) {
					opp.team = opp.team.map(member => {
						this.$store.commit('selectCache/addUser', member);
						return member.id;
					});
				}

				// if(Array.isArray(opp.sectors)) {
				// 	opp.sectors = opp.sectors.map(sector => {
				// 		return sector.id;
				// 	});
				// }

				if(Array.isArray(opp.documents)) {
					opp.documents = opp.documents.map(document => {
						this.$store.commit('selectCache/addAttachment', document);
						return document.uuid;
					});
				}

				opp.urgent = !!opp.urgent;
				opp.mandated = !!opp.mandated;

				opp.dealType = opp.dealTypeId;
				opp.currency = opp.currencyId;

                if(opp.primarySector && opp.primarySector.id) {
                    opp.primarySector = opp.primarySector.id;
                }

				if(opp.respondBy) {
					opp.respondBy = format(opp.respondBy, 'yyyy-MM-dd');
				}

				return opp;
			},
		},
	}
</script>
